module.exports = __webpack_public_path__ + "static/home1-header-right-be604d64cfd4f00184451db5fd8907f5.png";